// src/helpers/menu/buckets/modifierGroups.ts
var getModifierItemAmount = (quantityMode, modifierItem) => {
  var _a;
  switch (quantityMode) {
    case "x1,x2,x3" /* NUMBER */:
      return `x${(_a = modifierItem.defaultQuantitySelected) != null ? _a : 0}`;
    case "Lt,Reg,Ext" /* SIZE */:
      switch (modifierItem.defaultAmountSelected) {
        case "extra" /* EXTRA */:
          return "Ext";
        case "regular" /* REGULAR */:
          return "Reg";
        default:
          return "Lt";
      }
    default:
      return "";
  }
};

export { getModifierItemAmount };
